import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2rem',
    justifyContent: 'center',
    width: '420px',
    height: '420px',
    backgroundColor: '#E2F3FF',
    borderRadius: '50%',
  },
}))
